import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Seo } from "../../components/site/Seo";
import { Logo } from "../../components/site/Logo";
import { useAuth } from "../../components/admin/Auth";
import { LeadsTab } from "../../components/admin/LeadsTab";
import { BlogTab, SettingsTab } from "../../components/admin/ContentTabs";
import { AvailabilityTab } from "../../components/admin/AvailabilityTab";
import { PlanningTab } from "../../components/admin/PlanningTab";

const TABS = [["leads", "Demandes"], ["planning", "Planning"], ["availability", "Disponibilités"], ["blog", "Blog"], ["settings", "Avis clients"]];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("leads");
  return (
    <div className="min-h-screen bg-ag-mist" data-testid="admin-dashboard">
      <Seo title="Administration | A+ Glass Haguenau" description="Espace d'administration" path="/admin" noindex />
      <header className="flex items-center justify-between bg-white px-5 py-4 ring-1 ring-slate-200 lg:px-8">
        <Link to="/"><Logo /></Link>
        <div className="flex items-center gap-4 text-sm">
          <span className="hidden text-slate-500 sm:inline">{user?.email}</span>
          <button onClick={logout} className="btn btn-outline" data-testid="admin-logout-button"><LogOut className="h-4 w-4" />Déconnexion</button>
        </div>
      </header>
      <main className="mx-auto max-w-[1320px] px-5 py-8 lg:px-8">
        <div className="mb-6 flex flex-wrap gap-2">
          {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`rounded-full px-5 py-2 text-sm font-bold ${tab === k ? "bg-ag-blue text-white" : "bg-white ring-1 ring-slate-200"}`} data-testid={`admin-tab-${k}`}>{l}</button>)}
        </div>
        {tab === "leads" && <LeadsTab />}
        {tab === "planning" && <PlanningTab />}
        {tab === "availability" && <AvailabilityTab />}
        {tab === "blog" && <BlogTab />}
        {tab === "settings" && <SettingsTab />}
      </main>
    </div>
  );
}
